import Container from '@uikit/components/Container/Container';
import Headline from '@uikit/components/Headline/Headline';
import ImageGallery from '@uikit/components/ImageGallery/ImageGallery';
import PressImageWrapper from '@uikit/components/Press/PressImage/PressImageWrapper';
import TwoColumnContainer from '@uikit/components/TwoColumnContainer/TwoColumnContainer';
import PressArticleRichText from '@uikit/composites/PressArticleRichText/PressArticleRichText';

export const CmsComponentsPress = {
  'press-image-gallery': ImageGallery,
  'press-article-headline': Headline,
  'press-article-rich-text': PressArticleRichText,
  'press-image': PressImageWrapper,
  'press-additional-content-container': Container,
  'press-additional-content-two-column-container': TwoColumnContainer,
};
